const JobSkeleton = () => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl px-6 py-6 shadow-sm animate-pulse">
      <div className="w-full min-w-[800px]">
        
        {/* Header Skeleton */}
        <div className="grid grid-cols-7 gap-4 mb-4">
          {[...Array(7)].map((_, i) => (
            <div key={i} className="h-4 bg-gray-200 rounded"></div>
          ))}
        </div>

        {/* Body Skeleton */}
        <div className="grid grid-cols-7 gap-4">
          <div className="h-4 bg-gray-200 rounded w-28"></div>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
          <div className="h-4 bg-gray-200 rounded w-10"></div>
          <div className="h-4 bg-gray-200 rounded w-24"></div>
          <div className="h-8 bg-gray-200 rounded-full w-10"></div>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
          <div className="h-8 bg-gray-200 rounded-full w-24"></div>
        </div>

      </div>
    </div>
  );
};


export default JobSkeleton;